/* eslint-disable react-hooks/exhaustive-deps */
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/outline";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetTeamsAllQuery } from "../../features/teams/teamsApi";
import { changeType } from "../../features/teams/teamsSlice";
import Error from "../ui/Error";

export default function Select({ type, setType }) {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const [skip, setSkip] = useState(true);

  const { data, isLoading, isSuccess, isError, error } = useGetTeamsAllQuery(
    user?.email,
    { skip, refetchOnMountOrArgChange: true }
  );
  const [selected, setSelected] = useState(data);

  console.log(selected);

  useEffect(() => {
    setSkip((prev) => false);
console.log('redning')
    return () => {
      setSkip((prev) => true);
    };
  }, [dispatch]);

  let content = null;

  if (isLoading) {
    content = <div>Loading...</div>;
  } else if (isError) {
    content = <Error message="Any error occurred" />;
  } else if (!isLoading && data?.length === 0) {
    content = <div>You are not assign any team yet</div>;
  } else if (!isLoading && data?.length > 0) {
    content = data.map((item, itemIdx) => (
      <Listbox.Option
        key={itemIdx}
        className={({ active }) =>
          `relative cursor-default select-none py-2 pl-10 pr-4 ${
            active ? "bg-indigo-100 text-indigo-900" : "text-gray-900"
          }`
        }
        value={item}
        onClick={() => {
          setType(item?.type);
          dispatch(changeType(item?.type));
        }}
      >
        {({ selected }) => (
          <>
            <span
              className={`block truncate ${
                selected ? "font-medium" : "font-normal"
              }`}
            >
              {item?.type}
            </span>
            {selected ? (
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                <CheckIcon className="h-5 w-5" aria-hidden="true" />
              </span>
            ) : null}
          </>
        )}
      </Listbox.Option>
    ));
  }

  return (
    <div className="w-full">
      <span className="pl-1">Select Team (required)</span>
      <Listbox value={selected} onChange={setSelected}>
        <div
          className={`relative mt-1 z z-[200] overflow-auto ${
            data?.length > 0 ? "h-28" : "h-20"
          }`}
        >
          <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
            <span className="block truncate text-gray-700">
              {!selected?.type ? "Click here and select team" : selected?.type}
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute mt-1 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
              {content}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
}
